import React, { useState } from "react";
import SendIcon from "../../assets/icon/SendIcon";
import tripLogo from "../../assets/img/tripLogo.png";
import Left from "../../assets/icon/Left";
import { Link } from "react-router-dom";
import { axiosReq } from "../../commons/axiosReq"
import { useLocation } from "react-router-dom";
import {  useEffect, useRef } from "react";
const TripChat = () => {

  const location = useLocation();
  const recommendations = location?.state?.recommendations || "";
  const listRef = useRef(null);
  const endRef  = useRef(null);


  const [messages,
    setMessages] = useState([
      {
        text: "سلام! آماده‌ام تا مقصد مناسب سفر رو برات پیدا کنم 😊",
        sender: "bot"
      }
    ]);
  const [input,
    setInput] = useState("");

  const handleSend = async () => {
    if (!input.trim()) return;


    const newMessages = [
      ...messages,
      { text: input, sender: "user" }
    ];
    setMessages(newMessages);
    setInput("");

    try {

      const response = await axiosReq("chat_assist", "post", {
        prompt: input
      });


      const data = response?.data;
      console.log(data)
      if (Array.isArray(data?.recommendations)) {
        console.log(data?.recommendations)
        // setMessages((prev) => [
        //   ...prev,
        //   {
        //     sender: "bot",
        //     text: "",
        //     type: "recommendations",
        //     recommendations: data.recommendations 
        //   }
        // ]);

      var req = []
      data?.map((item) => {

        setMessages((prev) => [
          ...prev,
          {
            sender: "bot",
            text: {
              city: item.city,
              description: item.description
            },
            type: "recommendations"
          }
        ]);
      })

    

      } else {
        setMessages((prev) => [
          ...prev,
          {
            text: data?.answer || "پاسخی دریافت نشد.",
            sender: "bot"
          }
        ]);
      }
    } catch (err) {
      console.error("خطا در ارتباط با API:", err);
      setMessages((prev) => [
        ...prev,
        {
          text: "خطایی در ارتباط با سرور پیش آمد.",
          sender: "bot"
        }
      ]);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter")
      handleSend();
  };

  useEffect(() => {
    console.log(999)

    console.log(recommendations)
    if (Array.isArray(recommendations) && recommendations.length > 0) {
      var req = []
      recommendations?.map((item) => {

        setMessages((prev) => [
          ...prev,
          {
            sender: "bot",
            text: {
              city: item.city,
              description: item.description
            },
            type: "recommendations"
          }
        ]);
      })

    }
  }, []);

useEffect(() => {
    // اسکرول نرم به آخر
    endRef.current?.scrollIntoView({ behavior: "smooth", block: "end" });
  }, [messages]);
  
  // اختیاری: بارِ اول بدون انیمیشن بره پایین
  useEffect(() => {
    endRef.current?.scrollIntoView({ behavior: "auto", block: "end" });
  }, []);


  return (
    <div
      className="min-h-screen h-full flex flex-col lg:h-full  items-start bg-gray-100 tripBackgroud px-4 py-6">
      <div className="flex items-center mb-8">
        <img src={tripLogo} alt="Trip Logo" className="w-[50px] ml-2" />
        <span className="font-Beiruti text-[#265069] text-[20px]">
          چت بات گردشگری
        </span>
      </div>

      <div className=" w-[60%] mx-auto lg:w-full">

        <div >
          <div
            className="bg-white rounded-3xl shadow-lg p-8 w-full  mx-auto"
            id="chatBack">

            <div ref={listRef}
              className="w-full  flex-1 overflow-y-auto  p-4 space-y-3 h-[350px] min-h-[350px]">
              {messages?.map((msg, index) => (
                <div
                  key={index}
                  className={`flex ${msg.sender === "user" ? "justify-end" : "justify-start"}`}
                >
                  {msg.type === "recommendations" ? (
                    <div className="bg-cg text-gray-700 text-sm p-3 rounded-xl space-y-4 max-w-[75%]">
                      {/* {msg?.recommendations?.map((item, idx) => ( */}
                      <div style={{ marginBottom: "1.5rem" }}>
                        <h2 className="font-bold text-[#265069]">{msg?.text?.city}</h2>
                        <p className="whitespace-pre-line font-IRANYekanMedium">{msg?.text?.description}</p>
                      </div>
                      {/* ))} */}
                    </div>
                  ) : (
                    <div
                      className={`max-w-[75%] px-4 py-2 text-sm font-IRANYekanMedium ${msg.sender === "user"
                          ? "bg-cb text-blue-800 rounded-tr-xl rounded-tl-xl rounded-br-xl rounded-bl-sm"
                          : "bg-cg text-gray-700 rounded-tl-xl rounded-bl-xl rounded-tr-xl rounded-br-sm"
                        }`}
                    >
                      {msg.text}
                    </div>
                  )}
                </div>
              ))}

<div ref={endRef} />
            </div>
            <div className="w-full  mt-4 flex items-center gap-2">
              <input
                type="text"
                value={input}
                onChange={(e) => setInput(e.target.value)}
                onKeyDown={handleKeyDown}
                placeholder="پیام خود را بنویسید..."
                className="font-IRANYekanMedium flex-1 border border-[#0b94ca] rounded-full px-4 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-[#0b94ca]" />
              <button
                onClick={handleSend}
                className="bg-[#0b94ca] p-2 rounded-full text-white hover:bg-[#087cad]">
                <SendIcon className="w-5 h-5" />
              </button>
            </div>
          </div>
        </div>
      </div>
      <Link to={'/tripFirstStep'} className="w-[60%]  flex items-center justify-end mx-auto font-IRANYekanBold mt-2 text-[#265069]">
    
    بازگشت به عقب
    <Left/>
    </Link>
    </div>
  );
};

export default TripChat;
